import { useField } from "formik";
import { InputField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export const StaticFilenameRule: React.FC = () => {
  const { t } = useTranslation();

  const [{ value: type }] = useField("type");

  if (type !== "Constant") {
    return null;
  }

  return (
    <InputField
      name="value"
      label={t("inputFormats.actions.filenameRules.form.label.value")}
    />
  );
};
